import { commitMutation, graphql } from 'react-relay/legacy';
import FollowDealerButton from '../FollowDealerButton/FollowDealerButton'; // eslint-disable-line no-unused-vars

const mutation = graphql`
    mutation drsmFavoriteSellerMutation(
        $input: FavoriteSellerInput!
        $userId: String!
        $hasUserId: Boolean!
    ) {
        favoriteSeller(input: $input) {
            seller {
                ...FollowDealerButton_seller
            }
        }
    }
`;

function commit(environment, args) {
    const { userId, sellerPk, favoriteId, onSuccess, onFailure } = args;
    const variables = {
        input: {
            userId,
            sellerPk,
            favoriteId,
        },
        userId,
        hasUserId: !!userId,
    };

    commitMutation(environment, {
        mutation,
        variables,
        onCompleted: (payload, errors) => {
            if (errors) {
                onFailure(errors);
            } else {
                onSuccess(payload);
            }
        },
        onError: error => {
            onFailure([error]);
        },
    });
}

export default { commit };
